export interface IGetImputedInterestRateDto {
    from?: string | null
    to?: string | null
    rate?: number |null
}

export interface IPostImputedInterestRateDto{
    validFrom: string
}

export class ImputedInterestRate {
    from?: string | null
    to?: string | null
    rate?: number | null

    constructor(dto: IGetImputedInterestRateDto) {
        this.from = dto.from
        this.to = dto.to
        this.rate = dto.rate
    }
}
